import Masonry from "react-masonry-css";
import React from "react";

const MasonrySmallContainer = ({children}) =>
{
  const breakpointColumnsObj = {
    default: 4,
    1870: 3,
    1470: 2,
    700: 1,
  };

  return <Masonry
    breakpointCols={breakpointColumnsObj}
    className="my-masonry-grid"
    columnClassName="my-masonry-grid_config_column"
  >
    {children}
  </Masonry>
}

export default MasonrySmallContainer;